import { TableTemplate } from 'types/tableTemplate';

export const guideTableTemplate: TableTemplate[] = [
  {
    id: 'action',
    description: 'Ações',
    originalId: 'action',
    width: 60,
  },
  {
    id: 'id',
    description: 'ID',
    originalId: 'id',
    width: 60,
  },
  {
    id: 'formattedAppointmentDate',
    description: 'Consulta',
    originalId: 'appointment_date',
    width: 130,
  },
  {
    id: 'formattedPatientName',
    description: 'Paciente',
    originalId: 'formattedPatientName',
    width: 200,
  },
  {
    id: 'formattedProcedureName',
    description: 'Procedimento',
    originalId: 'formattedProcedureName',
    width: 240,
  },
  {
    id: 'formattedDoctorName',
    description: 'Parceiro',
    originalId: 'formattedDoctorName',
    width: 200,
  },
  {
    id: 'formattedMarkerName',
    description: 'Marcador',
    originalId: 'formattedMarkerName',
    width: 200,
  },
  {
    id: 'formattedValueMarker',
    description: 'Vl. Marcador',
    originalId: 'value_marker',
    width: 120,
    dataType: 'number',
  },
  {
    id: 'formattedValueProcedure',
    description: 'Vl. Proc.',
    originalId: 'value_procedure',
    width: 100,
    dataType: 'number',
  },
  {
    id: 'formattedValueDiscount',
    description: 'Vl. Desc.',
    originalId: 'value_discount',
    width: 100,
    dataType: 'number',
  },
  {
    id: 'formattedValueTotal',
    description: 'Vl. Total',
    originalId: 'value_total',
    width: 120,
    dataType: 'number',
  },
  {
    id: 'formattedStatus',
    description: 'Status',
    originalId: 'status',
    width: 120,
  },
];
